// Deconstructing props based off MUI TextField component
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDateInputFieldProps = (props: { [x: string]: any }) => {
  const {
    autoComplete,
    autoFocus,
    children,
    className,
    color,
    defaultValue,
    disabled,
    error,
    FormHelperTextProps,
    fullWidth,
    helperText,
    id,
    InputLabelProps,
    inputProps,
    InputProps,
    inputRef,
    label,
    maxRows,
    minRows,
    multiline,
    name,
    ownerState,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    ref,
    required,
    rows,
    size,
    type,
    value,
    ...other
  } = props;

  const updatedOwnerState = {
    ...props,
    autoFocus,
    color,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
  };

  return {
    // if there's a nested ownerState it means it's part of a date picker
    isFieldOnly: !ownerState?.ownerState,
    formControlWrapperProps: {
      className,
      FormHelperTextProps,
      InputLabelProps,
      helperText,
      label,
      inputId: id,
      disabled,
      error,
      fullWidth,
      required,
      color,
      ownerState: updatedOwnerState,
      size,
      ...other,
    },
    outlinedInputProps: {
      autoComplete,
      autoFocus,
      defaultValue,
      fullWidth,
      id,
      inputRef,
      multiline,
      name,
      onBlur,
      onChange,
      onFocus,
      rows,
      maxRows,
      minRows,
      placeholder,
      size,
      type,
      value,
      ...InputProps,
      inputProps: {
        ...inputProps,
        'aria-labelledby': label ? `${id}-label` : undefined,
        'aria-describedby': helperText ? `${id}-helper-text` : undefined,
      },
    },
  };
};
